import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1feef8a2&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1feef8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feef8a2",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteAboutProvider: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/site/about-provider.vue').default,SiteAwardsWinner: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/site/awards-winner.vue').default,ProductsCardsResults: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/cards/results.vue').default,ProductsProviderArticles: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/products/provider-articles.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/site/feefo.vue').default})
